import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const reviews = [
  {
      name: 'Jessica Harmon',
      location: 'Los Angeles, CA',
      text: 'I was pleasantly surprised by how quickly Diddy Baby Oil arrived! The shipping was incredibly fast, and the product came in perfect condition. I barely had to wait to start enjoying it, which was a nice bonus. The sleek design of the bottle and the subtle fragrance were exactly what I was hoping for. It’s clear that Diddy Baby Oil values a quality experience from start to finish. Highly recommended!',
      image: 'images/rw-1.jpg',
      image_size : {
        width : 500,
        height : 580,
      },
  },
  {
      name: 'Megan Foster',
      location: 'Miami, FL',
      text: 'I wasn’t sure what to expect, but Diddy Baby Oil blew me away. It feels amazing—so smooth and silky. The scent is perfect too—not too strong, just enough to make everything feel intimate. My partner and I use it regularly now, and it’s definitely added a little spark back into our time together. Highly recommend it if you’re looking for something that feels luxurious and intimate.',
      image: 'images/rw-2.jpg',
      image_size : {
        width : 500,
        height : 580,
      },
  },
  {
      name: 'Lena Parker',
      location: 'New York, NY',
      text: 'Diddy Baby Oil has really made a difference in how my partner and I connect. The texture is so smooth, and the scent is just right—not overpowering, but enough to set the mood. We’ve been using it for a few weeks now, and I can honestly say it’s added something extra to our time together. If you want to make things feel a little more special, this oil is definitely worth it.',
      image: 'images/rw-3.jpg',
      image_size : {
        width : 500,
        height : 580,
      },
  },
  {
      name: 'Rachel Adams',
      location: 'Dallas, TX',
      text: 'I didn’t expect Diddy Baby Oil to be such a game changer, but it really is. The smooth feel on the skin is incredible, and the scent is so inviting. It’s become part of our routine now, and it just makes everything feel more intimate and connected. I’m honestly surprised how much of a difference it’s made for us.',
      image: 'images/rw-1.jpg',
      image_size : {
        width : 500,
        height : 580,
      },
  },
  {
      name: 'Catherine Simmons',
      location: 'Chicago, IL',
      text: 'My partner and I tried Diddy Baby Oil on a whim, and I’m so glad we did. The texture is so soft and luxurious, and the scent is subtle but so sexy. It’s really added a new level of intimacy between us. It’s the kind of product that makes you feel closer, and I can’t recommend it enough if you want to bring a little more passion into your relationship.',
      image: 'images/rw-4.jpg',
      image_size : {
        width : 500,
        height : 580,
      },
  },
  {
      name: 'Tina Brooks',
      location: 'San Francisco, CA',
      text: 'I’m not usually into products like this, but Diddy Baby Oil has changed my mind. It’s silky smooth, smells amazing, and just sets the right tone. My partner and I love how it makes everything feel more connected and intimate. It’s the kind of little addition that makes a big difference in the mood. I’ll definitely be keeping this in our routine.',
      image: 'images/rw-5.jpg',
      image_size : {
        width : 500,
        height : 580,
      },
  }
];

const ReviewCarousel = () => {
  return (
    <section className="review-area">
      <div className="container-xl">
        <div className="row">
          <div className="col-12">
            <div className="heading-area">
              <h2>
                See What <span>200k+ Happy Freaks</span> Out there Are Saying
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div className="review-carousel">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]} // Import the modules
            navigation={{
              nextEl: ".review-swiper-button-next", // Custom navigation
              prevEl: ".review-swiper-button-prev",
            }}
            pagination={{
              el: ".review-swiper-pagination", // Custom pagination
              clickable: true,
            }}
            loop={true}
            slidesPerView={1}
            centeredSlides={true}
            spaceBetween={0}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            className="review-swiper"
          >
            {reviews.map((review, index) => (
              <SwiperSlide key={index}>
                <div className="review">
                  <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6 col-sm-12 order-2 order-lg-1 order-md-1">
                      <div className="review-image">
                        <img src={review.image} width={review.image_size.width} height={review.image_size.height} alt="Product" />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 order-1 order-lg-2 order-md-2">
                      <div className="review-content">
                        <div className="stars">★★★★★</div>
                        <p>{review.text}</p>
                        <div className="review-author">
                          <strong>{review.name}</strong>
                          <span>{review.location}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          {/* Custom Pagination */}
          <div className="swiper-pagination review-swiper-pagination"></div>
          {/* Custom Navigation Buttons */}
          <div className="swiper-button-prev review-swiper-button-prev">
            <img src="images/arrow-left.svg" alt="arrow left" />
          </div>
          <div className="swiper-button-next review-swiper-button-next">
            <img src="images/arrow-right.svg" alt="arrow right" />
          </div>

          </Swiper>
          
      </div>
    </section>
  );
};

export default ReviewCarousel;
